import React, { useEffect } from 'react';
import Hero from './Hero';
import About from './About';
import WhyUs from './WhyUs';
import ToolsTechnology from './ToolsTechnology';
import CTA from './CTA';
import Clients from './Clients';
import Testimonial from './Testimonial';

function HomeContainer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Hero />
      <About />
      <WhyUs />
      <CTA />
      <ToolsTechnology />
      <Clients />
      <Testimonial />
    </div>
  );
}

export default HomeContainer;
